import { createMuiTheme } from '@material-ui/core/styles';

const defaultTheme = createMuiTheme({
  typography: {
    "fontFamily": "Danske Text, Verdana, sans-serif",
    "fontSize": 14,
    "fontWeightLight": 300,
    "fontWeightRegular": 400,
    "fontWeightMedium": 500,
    h1: {
      "fontFamily": "Danske Human, Georgia, serif",
      "line-height": 1.2,
      "font-weight": 400,
      "fontSize": "2.75rem",
    },
    h3: {
      "fontFamily": "Danske Human, Georgia, serif",
      "line-height": 1.2,
      "font-weight": 400,
      "fontSize": "1.375rem",
      "padding-top": "1rem",
      "padding-bottom": "1rem",
    },
    h5: {
      "fontFamily": "Danske Text, Verdana, sans-serif",
      "line-height": 1.2,
      "font-weight": 400,
      "fontSize": "1rem",
      "padding-bottom": "1.5rem",
    },
  },
  palette: {
    primary: {
      main: "#009edd",
    },
  },  
  paddingBottom: {
    "padding-bottom": "1rem",
  },
  paddingTop: {
    "padding-top": "1rem",
  },
  doublePaddingBottom: {
    "padding-bottom": "2rem",
  },
  noPaddingBottom: {
    "padding-bottom": "0 !important",
  },
  noPaddingTop: {
    "padding-top": "0 !important",
  },
  noPaddingY: {
    "padding-top": "0 !important",
    "padding-bottom": "0 !important",
  },
  pageTitle: {
    textAlign: "center",
    paddingTop: "3rem",
    paddingBottom: "2rem",

  },
  textCenter: {
    textAlign: "center",
  },
  overrides: {
    MuiFormLabel: {
      asterisk: {
        color: '#db3131',
        '&$error': {
          color: '#db3131',
        },
      },
    },
  },
})

export default defaultTheme;